import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-30/task-02";

const task: Slide = {
  title: "Stereo reproduction...",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
